import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons"

export const AngleLeft = (props) => {
  return <FontAwesomeIcon faIcon={faAngleLeft} {...props} />
}
